import { ButtonGroup } from '@mui/material';
import MuiButton from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { aggregationPeriods } from '.';

const AggregationButtons = ({
  filter,
  setFilter,
  setSelected,
  isUsingCustomDate,
  getDefaultStartDateByAggregationPeriod,
}) => {
  const { t } = useTranslation();

  return (
    <ButtonGroup variant="outlined">
      {aggregationPeriods?.map((i) => (
        <MuiButton
          key={i}
          variant={filter.aggregationPeriod === i ? 'contained' : 'outlined'}
          onClick={() => {
            const startDateTime = isUsingCustomDate
              ? filter.startDateTime
              : getDefaultStartDateByAggregationPeriod(i);
            setFilter((curr) => ({
              ...curr,
              aggregationPeriod: i,
              startDateTime,
            }));
            setSelected(null);
          }}
        >
          <p style={{ textTransform: 'capitalize' }}>{t(i.toLowerCase())}</p>
        </MuiButton>
      ))}
    </ButtonGroup>
  );
};

export default AggregationButtons;
